export default class Themes {
  constructor(theme) {
    this.theme = theme;

    if (this.theme.colours) {
      for (let [key, value] of Object.entries(this.theme.colours)) {
        document.documentElement.style.setProperty('--' + key, value);
      }
    }
  }

  image(image) {
    return this.theme.images[image];
  }

  setFaviconAndTitle() {
    if (this.image('favicon')) {
      const favicon = this.image('favicon');
      const link = document.querySelector("link[rel*='icon']") || document.createElement('link');
      link.type = 'ico';
      link.rel = 'icon';
      link.href = favicon;
      document.getElementsByTagName('head')[0].appendChild(link);
    }

    if (this.theme.pageTitle) {
      document.title = this.theme.pageTitle;
    }
  }
}
